// noinspection DuplicatedCode

import {Composer, createI18n, I18n} from 'vue-i18n';
import {supportedLocales} from "@/shared/i18n/i18n.ts";

export class Locale {
    language: string;
    country: string;

    constructor(language: string, country: string) {
        this.language = language;
        this.country = country;
    }

    toString(): string {
        return `${this.language}-${this.country}`;
    }

    static fromJSON(jsonString: string): Locale {
        try {
            const obj = JSON.parse(jsonString);
            return new Locale(obj.language, obj.country);
        } catch (e) {
            return new Locale("nl", "BE");
        }
    }
}

let i18n: I18n | null = null;

export const t = (key: string): string => (i18n.global as Composer).t(key)

async function loadLocaleMessages(locale: Locale) {
    const language = locale.language.split("-")[0]
    try {
        const project = await import(`@/checkout/i18n/checkout_${language}.json`);
        return project.default;
    } catch (error) {
        console.error(`Failed to load locale ${language}, falling back to nl`, error);
        const fallbackProject = await import(`@/checkout/i18n/checkout_nl.json`);
        return fallbackProject.default;
    }
}

// Initialize the i18n instance
async function initializeI18n(myLocale: Locale, locales: Locale[]): Promise<I18n> {
    console.log("INIT I18N")
    const fallbackLocale = new Locale("nl", "BE");
    const activeLocale = locales.some(locale => locale.language === myLocale.language)
        ? myLocale
        : fallbackLocale;
    const messages: Record<string, Record<string, any>> = {};
    // Always load the fallback (nl) messages
    messages[fallbackLocale.toString()] = await loadLocaleMessages(fallbackLocale);
    // If active locale is different, load its messages too.
    if (activeLocale.toString() !== fallbackLocale.toString()) {
        messages[activeLocale.toString()] = await loadLocaleMessages(activeLocale);
    }
    i18n = createI18n({
        legacy: false,
        locale: activeLocale.toString(),
        fallbackLocale: fallbackLocale.toString(),
        globalInjection: true,
        messages,
    }) as I18n;

    return i18n;
}

export const activeLanguage = () => {
    try {
        const localeValue = (i18n.global as Composer).locale.value
        const activeLocale = supportedLocales.find((l) => l.toString() === localeValue.toString())
        if (activeLocale) {
            return activeLocale.language
        } else {
            return supportedLocales[0].language
        }
    } catch (e) {
        console.log("ACTIVE LANGUAGE")
    }

}


export {initializeI18n, i18n};